const reEnabledStatus = ({ hasData, releasedAt }: IReportCardAccess): ReportCardAccessStatus => {
  if (!hasData) return 'NO_DATA';
  return releasedAt ? 'AVAILABLE' : 'NOT_RELEASED';
};

// What a player revoke or re-enable returns, shown until the server answers. A re-enable in a revoked age
// group shows AVAILABLE until the reply corrects it; one never sent or without data goes back to that.
export const optimisticReportCardAccess = (
  access: IReportCardAccess,
  enabled: boolean,
  now: Date = new Date(),
): IReportCardAccess => (enabled
  ? { ...access, status: reEnabledStatus(access), revokedAt: null }
  : { ...access, status: 'REVOKED', revokedAt: now.toISOString() });

// What an age-group revoke or re-enable returns, shown until the server answers: players who could open
// theirs move to AGE_GROUP_REVOKED and back; a player revoked alone stays REVOKED either way.
export const optimisticReportCardAvailability = (
  availability: IReportCardAvailability,
  enabled: boolean,
  now: Date = new Date(),
): IReportCardAvailability => {
  const opened = availability.counts.available + availability.counts.ageGroupRevoked;
  return {
    ...availability,
    revokedAt: enabled ? null : availability.revokedAt || now.toISOString(),
    counts: { ...availability.counts, available: enabled ? opened : 0, ageGroupRevoked: enabled ? 0 : opened },
  };
};

// The age group's own include-non-concluded choice, shown until the server answers. Clearing it (null)
// leaves the effective value and its source as they were until the server resolves the default.
export const optimisticIncludeNonConcluded = (
  availability: IReportCardAvailability,
  value: boolean | null,
): IReportCardAvailability => (value === null
  ? { ...availability, ageGroupIncludeNonConcluded: null }
  : { ...availability, includeNonConcluded: value, includeNonConcludedSource: 'AGE_GROUP', ageGroupIncludeNonConcluded: value });
